module.exports = __webpack_public_path__ + "static/media/entrance.87386e64.jpg";